<template>
  <div id="app" :class="['app ' + $route.name, {'isAuth': isAuth}]">
    <transition name="fade">
      <div id="page" class="page" v-if="pageLoaded">
        <transition name="fade">
          <Menu v-if="menuVisible" @scrollToSection="scrollToSection" @openSignInModal="openSignInModal" @openSignUpModal="openSignUpModal" :currencyValue="currencyValue" :currencyCode="currencyCode" @changeCurrency="changeCurrency"/>
        </transition>
        <div v-if="$route.name != 'Login' && $route.name != 'Register'" class="mob menu-icon" @click="toggleMenu" :class="{'active': menuVisible}">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class='header-container' v-if="$route.name != 'Login' && $route.name != 'Register'">
          <Header :userBalance="userBalance" @chooseType="chooseType" @scrollToSection="scrollToSection" @openSignInModal="openSignInModal" @openSignUpModal="openSignUpModal" :currencyValue="currencyValue" :currencyCode="currencyCode" @changeCurrency="changeCurrency"/>
        </div>
        <router-view @registration="registration" @login="login" @forgotPass="forgotPass" @openOffer="openOffer" @setError="setError" @chooseType="chooseType" @deactivateCreatedItem="deactivateCreatedItem" :appActiveType="appActiveType" @setNewError="setNewError" @getProductPageContent="getProductPageContent" @editPrompt="editPrompt" :promptHistory="promptHistory" :orderHistory="orderHistory" @formatDate="formatDate"  :currency="currency"  @goToProduct="goToProduct" :productPageItem="productPageItem" :userName="userName" @openReadyModal="openReadyModal" :filter="productFilter" :createdHistory="createdHistory" />
        <div class='footer-container' v-if="$route.name != 'Login' && $route.name != 'Register'">
          <Footer @scrollToSection="scrollToSection" />
        </div>
        <transition name="fade">
          <SignInModal v-if="signInModalIsVisible" @closeSignInModal="closeSignInModal" @openSignUpModal="openSignUpModal" @login="login" @forgotPass="forgotPass"/>
        </transition>
         <transition name="fade">
          <SignUpModal v-if="signUpModalIsVisible" @closeSignUpModal="closeSignUpModal" @openSignInModal="openSignInModal" @registration="registration" />
        </transition>
        <transition name="fade">
          <ContactModal v-if="contactModalIsVisible" @closeContactModal="closeContactModal" @contactSubmit="contactSubmit" />
        </transition>
        <transition name="fade">
          <TopUpModal v-if="topUpModalVisible" @topUpSubmit="topUpSubmit" @setError="setError"/>
        </transition>
        <transition name="fade">
          <ReadyModal v-if="readyModalVisible"  @addToCart="addToCart" />
        </transition>
        <transition name="fade">
          <BuyModal v-if="buyModalVisible" @removeFromCart="removeFromCart" :cartContents="cartContents" :totalPrice="totalSum"/>
        </transition>
        <transition name="fade">
          <PromtCreate v-if="promptCreateModalIsVisible" :promptCreateModalIsVisible="promptCreateModalIsVisible" />
        </transition>
        <transition name="fade">
          <WithdrawModal v-if="withdrawModalIsVisible"  />
        </transition>
        <transition name="fade">
          <FilterModal v-if="filterModalIsVisible" @applyFilters="applyFilters" />
        </transition>
        <transition name="fade">
          <div @click="newError = ''" class="modal-error title small" v-if="newError">{{ newError }}</div>
        </transition>
        <transition name="fade">
          <VerifyModal v-if="verifyModalIsVisible" />
        </transition>
        <transition name="fade">
          <DeactivateModal v-if="deactivateModalIsVisible" />
        </transition>
        <transition name="fade">
          <SuccessCreateModal v-if="successCreateModalIsVisible" />
        </transition>
        <transition name="fade">
          <OfferModal v-if="offerModalIsVisible" />
        </transition>
        <transition name="fade">
          <AcceptOfferModal v-if="acceptOfferModalIsVisible" @setError="setError" />
        </transition>
        <transition name="fade">
          <DealModal v-if="dealModalIsVisible" @closeDealModal="closeDealModal" />
        </transition>
        <transition name="fade">
          <NoDealModal v-if="noDealModalIsVisible" />
        </transition>
        <transition name="fade">
          <SuccessBuyModal v-if="buySuccessModalIsVisible" />
        </transition>
        
        
        <div class="modal modal-overlay" v-if="cookesModalIsVisible">
          <div class="cookies-modal">
            <div class="title">Cookies In Use</div>
            <div class="desc chekbox-label">
              We employ cookies and similar technologies to optimize the functionality of our website. Majority of the cookies we use are essential for core functionality and therefore are set automatically without necessitating explicit consent. In addition, we may offer using non-essential cookies that enhance your interaction with our website but are not strictly necessary. Use of these non-essential cookies depends on your preferences. Please see our <a class="title" @click="goToPage('cookie')">Cookie Policy</a> for more detailed information.
            </div>
            <div class="buttons">
              <button class="button" @click="declineCookies">Decline</button>
              <button class="button blue" @click="acceptCookies">Got it</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {loadScriptsFromString} from "@/utils/load_scripts";
import {scroller} from 'vue-scrollto/src/scrollTo'
import Header from './components/Header.vue'
import Menu from './components/Menu.vue'
import Footer from './components/Footer.vue'
import SignInModal from './components/SignInModal.vue'
import SignUpModal from './components/SignUpModal.vue'
import ContactModal from './components/ContactModal.vue'
import TopUpModal from './components/TopUpModal.vue'
import ReadyModal from './components/ReadyModal.vue'
import BuyModal from './components/BuyModal.vue'
import PromtCreate from './components/PromtCreate.vue'
import WithdrawModal from './components/WithdrawModal.vue'
import FilterModal from './components/FilterModal.vue'
import VerifyModal from './components/VerifyModal.vue'
import DeactivateModal from './components/DeactivateModal.vue'
import SuccessCreateModal from './components/SuccessCreateModal.vue'
import OfferModal from './components/OfferModal.vue'
import AcceptOfferModal from './components/AcceptOfferModal.vue'
import DealModal from './components/DealModal.vue'
import NoDealModal from './components/NoDealModal.vue'
import SuccessBuyModal from './components/SuccessBuyModal.vue'
import i18n from "./i18n";



export default {
  name: 'app',
  components: {
    Header,
    Menu,
    Footer,
    SignInModal,
    SignUpModal,
    ContactModal,
    TopUpModal,
    ReadyModal,
    BuyModal,
    PromtCreate,
    WithdrawModal,
    FilterModal,
    VerifyModal,
    DeactivateModal,
    SuccessCreateModal,
    OfferModal,
    AcceptOfferModal,
    DealModal,
    NoDealModal,
    SuccessBuyModal
  },
  data: function () {
    return {
      pageLoaded: false,
      menuVisible: false,
      signInModalIsVisible: false,
      signUpModalIsVisible: false,
      contactModalIsVisible: false,
      isAuth: false,
      error: '',
      successMessage: '',
      orderHistory: [],
      promptHistory: [],
      depositHistory: [],
      createdHistory: [],
      totalSum: '0.00',
      textPageTitle: '',
      textPageHeader: '',
      textPageContent: '',
      productPageItem: null,
      imgDomain: '',
      textPageList: '',
      currency: '',
      currencyValue: '',
      currencyCode: '',
      currencyOptions: [],
      hostname: '',
      topUpModalVisible: false,
      readyModalVisible: false,
      readyPromt: false,
      buyModalVisible: false,
      userBalance: '0.00',
      userName: '',
      avatar_path: '',
      cartContents: [],
      editData: null,
      appActiveType: '',
      promptCreateModalIsVisible: false,
      newError: '',
      withdrawModalIsVisible: false,
      itemToBuy: '',
      filterModalIsVisible: false,
      productFilter: {},
      cookesModalIsVisible: false,
      settings: '',
      verifyModalIsVisible: false,
      withdrawConfirmModalIsVisible: false,
      withdrawAmount: null,
      deactivateModalIsVisible: false,
      itemToDeactivate: '',
      successCreateModalIsVisible: false,
      offerModalIsVisible: false,
      activeOffer: '',
      acceptOfferModalIsVisible: false,
      dealModalIsVisible: false,
      noDealModalIsVisible: false,
      buySuccessModalIsVisible: false,
      addToCartBtnLoader: false,
      previousRouteName: null
    }
  },
  watch: {
    $route() {
      window.scrollTo(0, 0);
      this.closeMenu();
      
      if (this.isAuth && this.$route.name !== this.previousRouteName) {
        this.refreshUserData();
      }
      
      if (this.$route.name === 'ProductList') {
        this.checkType();
      } else {
        this.appActiveType = '';
      }

      this.error = '';
      this.verifyModalIsVisible = false;
      this.withdrawConfirmModalIsVisible = false;
      
      this.previousRouteName = this.$route.name;
    }
  },
  methods: {
    refreshUserData() {
      Promise.all([
        this.getPromptHistory(),
        this.getOrderHistory(),
        this.getDepositHistory(),
        this.getCreatedHistory()
      ]).catch(error => {
        console.error('Error refreshing user data:', error);
      });
    },
    fetchTranslations() {
      this.$http.get(process.env.VUE_APP_API + 'localizations')
          .then((res) => {
            i18n.setLocaleMessage('en', res.data)
            i18n.locale = 'en';
          })
    },
    openBuySuccessModal() {
      this.buySuccessModalIsVisible = true;
    },
    closeBuySuccessModal() {
      this.buySuccessModalIsVisible = false;
    },
    openNoDealModal() {
      this.noDealModalIsVisible = true;
    },
    closeNoDealModal() {
      this.noDealModalIsVisible = false;
    },
    openDealModal() {
      this.dealModalIsVisible = true;
    },
    closeDealModal() {
      this.dealModalIsVisible = false;
    },
    openAcceptOfferModal() {
      this.acceptOfferModalIsVisible = true;
    },
    closeAcceptOfferModal() {
      this.acceptOfferModalIsVisible = false;
      this.error = '';
    },
    openOffer(item) {
      this.activeOffer = item;
      this.offerModalIsVisible = true;
    },
    closeOfferModal() {
      this.activeOffer = '';
      this.offerModalIsVisible = false;
    },
    openSuccessCreateModal() {
      this.successCreateModalIsVisible = true;
    },
    closeSuccessCreateModal() {
      this.successCreateModalIsVisible = false;
    },
    deactivateCreatedItem(id) {
      this.deactivateModalIsVisible = true;
      this.itemToDeactivate = id;
    },
    closeDeactivateModal() {
      this.deactivateModalIsVisible = false;
      this.itemToDeactivate = '';
    },
    setWithdrawAmount(amount) {
      this.withdrawAmount = amount;
    },
    openWithdrawConfirmModal() {
      this.closeWithdrawModal();
      this.withdrawConfirmModalIsVisible = true;
      this.$router.push({path: '/withdraw-confirm'});
    },
    sucessWithdrawConfirmModal() {
      this.$router.push({path: '/withdraw-success'});
    },
    failWithdrawConfirmModal() {
      this.$router.push({path: '/withdraw-fail'});
    },
    openVerifyModal() {
      this.verifyModalIsVisible = true;
    },
    closeVerifyModal() {
      this.verifyModalIsVisible = false;
    },
    cookiesModal() {
      const cookiesAccepted = localStorage.getItem('cookiesAccepted');

      if (!cookiesAccepted) {
          this.cookesModalIsVisible = true;
      }
    },
    declineCookies() {
      this.cookesModalIsVisible = false;
    },
    acceptCookies() {
      localStorage.setItem('cookiesAccepted', 'true');
      this.cookesModalIsVisible = false;
    },
    getCartContents() {
      this.$http.get(process.env.VUE_APP_API + 'cart/contents')
      .then((res) => {
        this.cartContents = res.data.cart.payload;
      })
      .catch((res) => {
        console.log(res);
      })
    },
    applyFilters(activeCategories, activeTags) {
      this.productFilter = {
        activeCategories,
        activeTags
      };
    },
    openBuyModal(item) {
      this.closeMenu();
      if (this.isAuth) {
        if (item) {
          this.addToCart(item);
        }
        this.buyModalVisible = true;
      } else {
        this.openSignInModal();
      }
      
    },
    setError(error) {
      this.error = error;
    },
    setNewError(error) {
      let self = this;
      this.newError = error;
      setTimeout(()=> {
        self.newError = '';
      }, 2500)
    },
    getCurrencies() {
      return this.$http.get(process.env.VUE_APP_API + 'currencies')
      .then((res) => {
          const that = this;
          
          this.currencyOptions = res.data.payload;

          if (localStorage.getItem("currency")) {
            this.currencyCode = localStorage.getItem("currency");

            const currency = res.data.payload.find(({code}) => code === that.currencyCode);

            if (currency) {
              this.currencyValue = currency.value;
              this.currency = currency.symbol;
            }
          } else {
            this.currencyCode = this.currencyOptions[0].code;
            this.currency = this.currencyOptions[0].symbol;
            this.currencyValue = this.currencyOptions[0].value;
          }
      })
      .catch(() => {
       
      })
    },
    changeCurrency(item) {
      if (this.currencyCode === item) return; // Don't update if currency hasn't changed
      
      this.currencyCode = item;
      this.checkCurrency();
    },
    checkCurrency() {
      const that = this;
      const currency = this.currencyOptions.find(({code}) => code === that.currencyCode);

      if (currency) {
        this.currency = currency.symbol;
        this.currencyValue = currency.value;
        
        if (this.isAuth) {
          this.refreshUserData();
          this.getCartContents();
          this.getProfileData();
        }
      }
    },
    chooseType(item) {
      if (this.appActiveType != item.title) {
        this.$router.push({path: '/product-list' + item.url});
      }
      let self = this;
      this.appActiveType = '';
      setTimeout(function() {
        self.appActiveType = item.title;
      },200)
      
    },
    scrollToSection(section) {
      if (this.$route.name != 'Home') {
        this.$router.push({path: '/'});
      }
      var options = {
          offset: -100
      }

      setTimeout(()=> {
        const firstScrollTo = scroller()
        firstScrollTo('#' + section, 1000, options)
      }, 1000)
    },
    goToPromtCreate() {
      this.promptCreateModalIsVisible = true;
    },
    closePromptCreateModal() {
      this.promptCreateModalIsVisible = false;
    },
    topUpSubmit(data) {
      this.$http.post(process.env.VUE_APP_API + 'deposit/checkout', data)
      .then((res) => {
        if (res.data.status == "OK") {
          window.location = res.data.redirect_url;
        } else {
          this.error = res.response.data.message
        }
      })
      .catch((res) => {
        this.error = res.response.data.message
        if(res.response.status === 401) {
          this.openSignInModal();
        }
      })
    },
    addToCart() {
      this.addToCartBtnLoader = true;
      let param = {
        'item_id': this.itemToBuy.id
      }
      this.$http.post(process.env.VUE_APP_API + 'purchase/buy', param)
      .then((res) => {
        if (res.data.status == "OK") {
          this.getProfileData();
          this.closeReadyModal();
          this.openBuySuccessModal();
        }
        this.addToCartBtnLoader = false;
      })
      .catch((res) => {
        this.error = res.response.data.message;
        this.addToCartBtnLoader = false;
      })
    },
     buyProduct() {
      this.$http.post(process.env.VUE_APP_API + 'cart/purchase')
      .then((res) => {
        if (res.data.status == "OK") {
          this.successMessage =  'Success';
          this.getProfileData();
          this.closeBuyModal();
          this.$router.push({path: '/profile/purchased-poducts'});
        } else {
          this.error = res.data.message
        }
      })
      .catch((res) => {
        this.error = res.response.data.message
      })
    },
    closeBuyModal() {
      this.buyModalVisible = false;
      this.clearError();
    },
    openWithdrawModal() {
      this.withdrawModalIsVisible = true;
    },
    closeWithdrawModal() {
      this.withdrawModalIsVisible = false;
      this.clearError();
    },
    setReadyPromt() {
      this.readyPromt = true;
    },
    openFilterModal() {
      this.filterModalIsVisible = true;
    },
    closeFilterModal() {
      this.filterModalIsVisible = false;
    },
    openReadyModal(item) {
      this.itemToBuy = item;
      this.readyModalVisible = true;
    },
    closeReadyModal() {
      this.itemToBuy = '';
      this.error = '';
      this.readyModalVisible = false;
    },
    openTopUpModal() {
      this.topUpModalVisible = true;
    },
    closeTopUpModal() {
      this.setError('');
      this.topUpModalVisible = false;
    },
    getDomainName(hostName) {
      return hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1);
    },
    closeMenu() {
      this.menuVisible = false;
      document.body.style.overflow = "auto";
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
      window.scrollTo(0, 0);
      if (this.menuVisible) {
        document.body.style.overflow = "hidden";
      } else {
         document.body.style.overflow = "auto";
      }
    },
    menuHeight() {
      const doc = document.documentElement;
      doc.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
    },
    openSignInModal() {
      this.clearError();
      this.$router.push({ path: '/login' });
    },
    openSignUpModal() {
      this.clearError();
      this.$router.push({ path: '/register' });
    },
    clearError() {
      this.error = '';
    },
    closeSignUpModal() {
      this.$router.push({ path: '/' });
      this.clearError();
    },
    closeSignInModal() {
      this.$router.push({ path: '/' });
      this.clearError();
    },
    openContactModal() {
      this.contactModalIsVisible = true;
    },
    closeContactModal() {
      this.contactModalIsVisible = false;
      this.clearError();
    },
    login(data) {
      this.$http.post(process.env.VUE_APP_API + 'login', data)
      .then((res) => {
        if (res.data.status == "OK") {
          this.isAuth = true;
          this.closeSignInModal();
          this.refreshUserData();
          this.getProfileData();
          this.getCartContents();
        } else {
          this.error = res.data.message
        }
      })
      .catch((res) => {
          this.error = res.response.data.message;
      })
    },
    forgotPass(data) {
      let self = this;
      this.$http.post(process.env.VUE_APP_API + 'user/reset-password', data)
      .then((res) => {
        if (res.data.status == "OK") {
          this.successMessage = 'Success';
          this.error = ''
          setTimeout(()=> {
            self.successMessage = '';
          }, 2000)
        } else {
          this.error = res.response.data.message
        }
      })
      .catch((error) => {
        this.error = error.response.data.message
      })
    },
    contactSubmit(data) {
      let self = this;
      this.$http.post(process.env.VUE_APP_API + 'contact-us', data)
      .then((res) => {
        if (res.data.status == "OK") {
          self.clearError();
          self.successMessage = 'Thank you!'
          self.setTimeout(function() {
            self.successMessage = '';
            self.closeContactModal();
          }, 3000)
        } else {
          this.error = res.data.message
        }
      })
      .catch((res) => {
          this.error = res.response.data.message;
      })
    },
    registration(data) {
      let self = this;
      if (data.password !== data.passConfirm) {
        this.error = 'Password confirmation failed!';
      } else {
        this.$http.post(process.env.VUE_APP_API + 'register', data)
        .then((res) => {
          if (res.data.status == "OK") {
            this.clearError();
            self.isAuth = true;
            self.closeSignUpModal();
            this.getProfileData();
          } else {
            this.error = res.data.message
          }
        })
        .catch((res) => {
            this.error = res.response.data.message;
        })
      }
    },
    logout() {
      this.$http.post(process.env.VUE_APP_API + 'logout')
      .then(() => {
        if (this.$route.name != 'Home') {
          this.$router.push({ path: '/' })
        }
        this.isAuth = false;
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.openSignInModal();
        }
      })
    },
    getPromptHistory() {
      this.$http.get(process.env.VUE_APP_API + 'user/media/purchased')
      .then((res) => {
        this.promptHistory = res.data.payload
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.openSignInModal();
        }
      })
    },
    getOrderHistory() {
      this.$http.get(process.env.VUE_APP_API + 'purchase/history')
      .then((res) => {
        this.orderHistory = res.data.payload
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.openSignInModal();
        }
      })
    },
    getDepositHistory() {
      this.$http.get(process.env.VUE_APP_API + 'deposit/history')
      .then((res) => {
        this.depositHistory = res.data.payload
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.openSignInModal();
        }
      })
    },
    getCreatedHistory() {
      this.$http.get(process.env.VUE_APP_API + 'offer/history')
      .then((res) => {
        this.createdHistory = res.data.payload
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.openSignInModal();
        }
      })
    },
    getProfileData() {
      this.$http.get(process.env.VUE_APP_API + 'user/profile')
      .then((res) => {
        this.userName = res.data.name;
        this.userBalance = res.data.balance;
        this.avatar_path = res.data.avatar_path;
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      })
    },
    formatDate(num) {
      let objectDate = new Date(num * 1000);
      let day = objectDate.getDate();
      if (day < 10) {
          day = '0' + day;
      }
      let month = objectDate.getMonth() + 1;
      if (month < 10) {
          month = `0${month}`;
      }
      let year = objectDate.getFullYear();

      function padTo2Digits(x) {
        return String(x).padStart(2, '0');
      }
      let hoursAndMinutes = padTo2Digits(objectDate.getHours()) + ':' + padTo2Digits(objectDate.getMinutes());
      let format = day + "." + month + "." + year + ' ' + hoursAndMinutes;

      return format
    },
    goToProduct(item) {
      this.$router.push({path: '/products/' + item.id, params: {data: item.id}});
      this.getProductPageContent(item.id);
    },
    getProductPageContent(id) {
      this.productPageItem = '';
      this.$http.get(process.env.VUE_APP_API + 'products/' + id + '/info')
      .then((res) => {
        this.productPageItem = res.data.payload;
      })
      .catch(() => {
        
      })
    },
    goToPage(item) {
      let newItem;
      if (item == 'privacy') {
        for (let i = 0; i < this.textPageList.length; i++) {
          if (this.textPageList[i].title.toLowerCase().includes('privacy')) {
            newItem = this.textPageList[i].id;
          } 
        }
      } else if (item == 'terms') {
        for (let i = 0; i < this.textPageList.length; i++) {
          if (this.textPageList[i].title.toLowerCase().includes('terms')) {
            newItem = this.textPageList[i].id;
          } 
        }
      } else if (item == 'cookie') {
        for (let i = 0; i < this.textPageList.length; i++) {
          if (this.textPageList[i].title.toLowerCase().includes('cookie')) {
            newItem = this.textPageList[i].id;
          } 
        }
      } else {
        newItem = item
      }
      this.$router.push({path: '/pages/' + newItem, params: {data: newItem}})
      this.getTextPageContent(newItem);
    },
    getTextPageContent(id) {
      this.textPageTitle = '';
      this.textPageHeader = '';
      this.textPageContent = '';
      this.$http.get(process.env.VUE_APP_API + 'static-pages/' + id)
      .then((res) => {
        this.textPageTitle = res.data.payload.title;
        this.textPageContent = res.data.payload.content;
        this.textPageHeader = res.data.payload.header;
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.openSignInModal();
        }
      })
    },
    getTextPages() {
      this.$http.get(process.env.VUE_APP_API + 'static-pages')
      .then((res) => {
        this.textPageList = res.data.payload
      })
      .catch(() => {
         
      })
    },
    isElementVisible(element) {
      const computedStyle = window.getComputedStyle(element);
      const isVisible = 
        computedStyle.display !== 'none' &&
        computedStyle.visibility !== 'hidden' &&
        parseInt(computedStyle.width, 10) > 0 &&
        parseInt(computedStyle.height, 10) > 0;
      return isVisible;
    },
    editPrompt(item) {
      this.editData = item;
      this.goToPromtCreate();
    },
    clearEditData() {
      this.editData = null;
    },
    checkType() {
      if (this.$route.params.type == 'images') {
        this.appActiveType = 'Images';
      } else if (this.$route.params.type == 'texts') {
        this.appActiveType = 'Texts';
      }
    },
    getGoogleTagManagerSnippet() {
      this.$http.get(process.env.VUE_APP_API + 'settings')
      .then((res) => {
        this.settings = res.data.payload;
        const snippet = res.data.payload.google_tag;

        if (snippet) {
          loadScriptsFromString(snippet);
        }
      })
      .catch((error) => {
        console.error("Error fetching Google Tag Manager snippet:", error);
      });
    },
   
  },
  mounted: function() {
    this.fetchTranslations();
    this.hostname = this.getDomainName(window.location.hostname)
    this.currency = process.env.VUE_APP_CURRENCY;
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.pageLoaded = true;
    let self = this;
    this.getCurrencies();
    this.getTextPages();
    this.checkType();
    window.addEventListener("resize", self.menuHeight);
    self.menuHeight();
    this.cookiesModal();
    this.getGoogleTagManagerSnippet();
    
    self.$http.get(process.env.VUE_APP_API + 'is-auth')
    .then((res) => {
        console.log('auth: ' + res.data.authenticated);
        self.isAuth = res.data.authenticated

        if (res.data.authenticated) {
          self.refreshUserData();
          self.getProfileData();
          self.getCartContents();
        }
    })
    .catch(() => {
       
    })
  },
  computed: {
    
  }
}
</script>
